<ng-container *ngIf="checkPermissions(actionName)">
    <button mat-mini-fab color="primary" class="positionAbsoliteRight0" aria-label="edit company" (click)="openChangeCompanyEdit()">
        <mat-icon>edit</mat-icon>
    </button>
</ng-container>